import CloseIcon from "@mui/icons-material/Close";
import { Drawer } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ProductType } from "../../shared/enums/ProductType";
import { WizardStep } from "../../shared/enums/WizardStep";
import { linkHelper } from "../../shared/helpers/linkHelper";
import { useMarket } from "../../store/hooks/useMarket";
import { CartOptional, CartProduct } from "../../store/interfaces/Cart";
import "./Cart.scss";
import CartItem from "./CartItem";

interface CartProps {
  cartOptional: CartOptional;
  cartProduct: CartProduct;
  onCloseClick(): void;
  showCart: boolean;
  toggleDrawer(
    event: React.KeyboardEvent | React.MouseEvent,
    reason: "backdropClick" | "escapeKeyDown"
  ): void;
}

const Cart = ({
  cartOptional,
  cartProduct,
  onCloseClick,
  showCart,
  toggleDrawer,
}: CartProps) => {
  const { t } = useTranslation("cart");
  const market = useMarket();
  const productLink = linkHelper.link(WizardStep.Product, market);
  const optionalLink = linkHelper.link(WizardStep.Optional, market);

  return (
    <Drawer
      anchor="right"
      open={showCart}
      onClose={toggleDrawer}
      PaperProps={{
        sx: {
          width: "100%",
          "@media (min-width: 480px)": {
            width: "400px",
          },
        },
      }}
    >
      <div className="cartContainer">
        <div className="cartHeader">
          <h3>{t("yourproducts")}</h3>
          <div className="cartHeaderIcon" onClick={onCloseClick}>
            <CloseIcon />
          </div>
        </div>
        <div className="cartProduct">
          {cartProduct?.tiltrotator && (
            <CartItem
              configLink={productLink}
              market={market}
              product={cartProduct?.tiltrotator}
              productType={ProductType.Rototilts}
            />
          )}
          {cartProduct?.machineFixing && (
            <CartItem
              configLink={productLink}
              market={market}
              product={cartProduct?.machineFixing}
              productType={ProductType.MachineFixings}
            />
          )}
          {cartProduct?.upperBracket && (
            <CartItem
              configLink={productLink}
              market={market}
              product={cartProduct?.upperBracket}
              productType={ProductType.UpperBrackets}
            />
          )}
          {cartProduct?.lowerBracket && (
            <CartItem
              configLink={productLink}
              market={market}
              product={cartProduct?.lowerBracket}
              productType={ProductType.LowerBrackets}
            />
          )}
          {cartProduct?.grappleModule && (
            <CartItem
              configLink={productLink}
              market={market}
              product={cartProduct?.grappleModule}
              productType={ProductType.GrappleModules}
            />
          )}
          {cartProduct?.toolsProductItems &&
            cartProduct?.toolsProductItems.map((toolsProductItem) => (
              <CartItem
                configLink={productLink}
                key={toolsProductItem.id}
                market={market}
                product={toolsProductItem}
              />
            ))}
          {cartOptional?.tiltrotator && (
            <CartItem
              configLink={optionalLink}
              market={market}
              product={cartOptional?.tiltrotator}
              productType={ProductType.Rototilts}
            />
          )}
          {cartOptional?.grappleModule && (
            <CartItem
              configLink={optionalLink}
              market={market}
              product={cartOptional?.grappleModule}
              productType={ProductType.GrappleModules}
            />
          )}
          {cartOptional?.machineFixing && (
            <CartItem
              configLink={optionalLink}
              market={market}
              product={cartOptional?.machineFixing}
              productType={ProductType.MachineFixings}
            />
          )}
          {cartOptional?.toolsProductItems &&
            cartOptional?.toolsProductItems.map((toolsProductItem) => (
              <CartItem
                configLink={optionalLink}
                key={toolsProductItem.id}
                market={market}
                product={toolsProductItem}
              />
            ))}
        </div>
      </div>
    </Drawer>
  );
};

export default Cart;
